import React from "react";
import Lottie from "react-lottie";
import { championSettings } from "../../views/calificacion/Styles";

export const Champion = () => {
  return <Lottie options={championSettings} width={400} />;
};
